import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Kitchen from "../components/Kitchen/kitchen";
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import CustomBanner from '../components/Banner/customBanner';
import DocumentMeta from 'react-document-meta';
import UpcomingEvents from "../components/upcomingevents/upcomingevents";


function RadhaMadhavKitchen() {
const meta = {
    title: "Kitchen - Radha Madhav Kitchen of Krishna Temple Milwaukee",
    description: "Explore the kitchen of Radha Madhav Krishna Temple in Milwaukee. Discover our delicious vegetarian meals and community dining experience.",
    keywords: "Kitchen, Radha, Madhav, Krishna, Temple, Milwaukee, vegetarian, sattvic, meals, community, dining",
    canonical: "https://www.krishnatemplemilwaukee.org/radha-madhav-kitchen",
    meta: {
      charset: 'utf-8',
      name: {
        keywords: "Kitchen, Radha, Madhav, Krishna, Temple, Milwaukee, vegetarian, sattvic, meals, community, dining"
      }
    },
    og: {
      title: "Kitchen - Radha Madhav Kitchen of Krishna Temple Milwaukee",
      description: "Explore the kitchen of Radha Madhav Krishna Temple in Milwaukee. Discover our delicious vegetarian meals and community dining experience.",
      url: "https://www.krishnatemplemilwaukee.org/radha-madhav-kitchen",
      image: "/images/radhamadhavkitchen.jpg"
    }
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <UpcomingEvents />
      <HomeBanner />
      <Kitchen />
      <CustomBanner sideText={"Call/Text: 262-219-9086"} sideText2={"Call/Text: 262-955-3216"} slideUrl={""}/>
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default RadhaMadhavKitchen